import React from 'react';
import contact from "../objects/contact.json"

const Contact = () => {
    return (
        <section className="contact-section bg-black mt-5" id="contact">
            <div className="container">
                <div className="col-sm-12 py-5 ">
                    <h1 className="mt-5 text-center text-black wow bounceInLeft project" data-wow-delay="0.3s" data-wow-duration="1s" id="contact-title">Contacts</h1><br />
                    <center>
                        <div className="nbsp3 wow bounceInRight" data-wow-delay="0.3s" data-wow-duration="1s"></div>
                    </center>
                    <div className="text-center question font-weight-bolder" id="questions">Have a question or want to work together?</div>

                </div>

                <form className="contact-form" method="POST">
                    <input type="hidden" name="form-name" value="contact" />
                    <input type="text" name="name" className="contact-form-text wow fadeInLeft" data-wow-delay="0.3s" data-wow-duration="1s" placeholder="your name" />
                    <input type="email" name="email" className="contact-form-text wow fadeInRight" data-wow-delay="0.3s" data-wow-duration="1s" placeholder="your email" />
                    <input type="number" name="number" className="contact-form-text wow fadeInLeft" data-wow-delay="0.3s" data-wow-duration="1s" placeholder="your phone" />
                    <textarea className="contact-form-text wow fadeInRight" name="message" data-wow-delay="0.3s" data-wow-duration="1s" placeholder="your message">
                    </textarea>
                    <div data-netlify-recaptcha="true"></div>
                    <button type="submit" className="contact-form-btn wow fadeInLeft" data-wow-delay="0.3s" data-wow-duration="1s" >Send</button>
                </form>

                <div className="row">
                {contact.map((c, key) =>{
                    return (
                        <div className="col-md-4 mb-3 mb-md-0 wow jackInTheBox" data-wow-delay="0.3s" data-wow-duration="1s" key={key}>
                        <div className="card-1 py-4 h-100">
                            <div className="card-body text-center">
                                <i className={`card-icon mb-2 ${c.icon}`}></i>
                                <h4 className="text-uppercase m-0">{c.type}</h4>
                                <hr className="my-4" />
                                {c.aTag ? <div className="contact-detail font-weight-bolder" ><a href='#contact' className="text-danger active scroll">{c.detail}</a></div> : <div className="contact-detail font-weight-bolder" >{c.detail}</div>}                               
                            </div>
                        </div>
                    </div>
                    )
                })}
                </div>
                
            </div>
        </section>

    )
}

export default Contact;